module.exports = __webpack_public_path__ + "img/mypage-active.1f75179c.png";